<template>
  <div class="container">
    <div class="notice">{{notice}}</div>
    <div v-for="(formItemInfo, index) in formInfo" :key="index">
      <!--文本提交-->
      <text-proof
        v-if="formItemInfo.type === '1'"
        :ref="formItemInfo.name"
        :formItemInfo="formItemInfo"
        @onSubmit="getTextInput"
      >
      </text-proof>
      <!--图片上传-->
      <img-proof
        v-else-if="formItemInfo.type === '2'"
        :ref="formItemInfo.name"
        :formItemInfo="formItemInfo"
        @onSubmit="getImgProof"
      >
      </img-proof>
    </div>
    <z-button-group>
      <z-button type="primary" @click="handleSubmit">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Button, ButtonGroup, Dialog } from '@zz-common/zz-ui'
import TextProof from './TextProof'
import ImgProof from './ImgProof'
import { getSubmitConfig, submitAuditInfo } from '../../api/resourceApi'
import { queryParams, getCookie } from '../../lib/utils'

const query = queryParams()

export default {
  name: 'ProductQua',
  data() {
    return {
      notice: '',
      formInfo: [],
      infoId: query.infoId || this.$route.query.infoId,
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      reasonId: query.reasonId || this.$route.query.reasonId,
      proofList: []
    }
  },
  methods: {
    async getFormInfo() {
      const res = await getSubmitConfig({ infoId: this.infoId, sourceCode: this.sourceCode })
      console.log('checkStatusres', res);
      const { notice = '', formInfo = [], status } = res.configVo
      this.notice = notice
      this.formInfo = [...formInfo]
      if (res.msg == 'HIT') {
        this.showIntercept(res)
        return
      }
      if (status == 1) { // 判断今日是否已达到提交上限
        Dialog.alert({
          message: '您已到达今日提交上限，请明日再提交'
        }).then(() => {
          native.close()
        })
      }
    },
    async submitFormInfo(params) {
      console.log('submitParms', params)
      const res = await submitAuditInfo(params)
      if (res.msg == 'HIT') {
        this.showIntercept(res)
        return
      }
      console.log('submitFormInfores', res);
      const { status } = res
      if (status == 0) {
        this.$router.replace({
          path: '/productqua/result'
        })
      }
    },
    pushToLoacalaProoflist(val) {
      const { name, type, value } = val
      const newValue = type === '2' ? value.join('|') : value
      // 将用户输入的信息,转换为可以提交给后端的信息
      const originValue = this.proofList.filter((item) => item.name === name)[0]
      if (originValue) {
        originValue.value = newValue // 如果用户之前已经选择某个值,则新值进来之后,覆盖老的值
      } else {
        this.proofList.push({
          type,
          value: newValue,
          name
        })
      }
      console.log('this.localFormData: ', this.proofList)
    },
    getTextInput(value) {
      this.pushToLoacalaProoflist(value)
    },
    getImgProof(value) { // 处理图片上传url
      this.pushToLoacalaProoflist(value)
    },
    checkValidity() { // 执行校验逻辑
      let validation = true
      this.formInfo &&
        this.formInfo.forEach((formItemInfo) => {
          const { name, needHide } = formItemInfo
          if (!needHide) {
            // 使用this.$refs[componentRef]时要注意,有些组件虽然在dom中,但是是隐藏的,所以,不能仅仅根据组件是否在dom中判断组件是否可用
            const componentObj = this.$refs[name]
            console.log('componentObj', componentObj);
            if (Array.isArray(componentObj)) {
              // 因为formRefs中的元素,是放置在v-for指令中的,所以,通过$refs引用的对象是个数组
              componentObj.forEach((cmpItem) => {
                if (cmpItem.customValidate) {
                  validation = cmpItem.customValidate() // 触发组件的校验逻辑
                  if (!validation) return true
                }
              })
              if (!validation) return true
            } else {
              if (componentObj.customValidate) {
                validation = componentObj.customValidate()
                if (!validation) return true
              }
            }
          }
        })
      return validation
    },
    handleSubmit() {
      const checkResult = this.checkValidity()
      console.log('handleSubmit', checkResult)
      if (checkResult) { // 通过校验
        console.log('submitParams', this.proofList)
        const proofList = JSON.stringify([...this.proofList])
        console.log(typeof proofList)
        this.submitFormInfo({
          reqUid: getCookie('uid'),
          proofList,
          infoId: this.infoId,
          sourceCode: this.sourceCode - 0,
          reasonId: this.reasonId - 0
        })
      }
    },
    showIntercept(data) {
      const { punishDesc, punishTitle, retButtons } = data.notifyData
      let confirm = {}
      let cancel = {}
      const dialogParams = {
        title: punishTitle,
        message: punishDesc
      }
      if (retButtons) {
        retButtons.forEach((btn) => {
          if (Number(btn.type) === 2) {
            cancel = btn
            dialogParams.showCancelButton = true
            dialogParams.cancelButtonText = btn.buttonDesc
          } else {
            confirm = btn
            dialogParams.confirmButtonText = btn.buttonDesc
          }
        })
      }
      Dialog(dialogParams)
        .then(() => {
          if (confirm.mUrl) {
            native.skipToUrl({
              targetUrl: confirm.mUrl,
              needClose: '1'
            })
          } else {
            native.close()
          }
        })
        .catch(() => {
          if (cancel.mUrl) {
            native.skipToUrl({
              targetUrl: cancel.mUrl,
              needClose: '1'
            })
          } else {
            native.close()
          }
        })
    }
  },
  components: {
    TextProof,
    ImgProof,
    zButton: Button,
    zButtonGroup: ButtonGroup
  },
  created() {
    native.setTitle({
      title: '商品资质核验'
    })
    this.getFormInfo()
  }
}

</script>
<style lang="less">
  @import 'auditSubmit.less';
</style>
